import SiteButton_ButtonShadowRightComponent from '../components/SiteButton/viewer/skinComps/BaseButton/ButtonShadowRight.skin';
import SiteButton_ButtonShadowRightController from '../components/SiteButton/viewer/SiteButton.controller';


const SiteButton_ButtonShadowRight = {
  component: SiteButton_ButtonShadowRightComponent,
  controller: SiteButton_ButtonShadowRightController
};


export const components = {
  ['SiteButton_ButtonShadowRight']: SiteButton_ButtonShadowRight
};

